<template>   
<div class="no-class">     
<div v-if="roleType==2">       
<div class="no-img">
</div>       
<div class="no-text">还没有创建班级
</div>       
<el-button autoId="btn_buildClass" @click="buildClass" type="primary" size="small">去创建 
</el-button>     
</div>     
<div v-else>       
<div class="no-img no-img1">
</div>       
<div class="no-text">未绑定班级
</div>       
<el-button autoId="btn_joinClass" @click="joinClass" type="primary" size="small"><i class="iconfont icon-plus"></i> 加入班级 
</el-button>       
<div class="no-text1"><i class="iconfont icon-location"></i>请联系本校该教材的教师，获取班级码加入班级。
</div>     
</div>     <Join ref="join" :fromBookPreview="true" @refresh="refresh" />     <AddClass ref="addClass" @success="refresh" />   
</div> </template>

<script>
import AddClass from '@/views/my/teachingSpace/components/addClass';
import { mapGetters } from 'vuex'
export default {
  name: "NoClass",
  props: {
    bookId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
    }
  },
  components: {
    AddClass,
  },
  computed: {
    ...mapGetters(['classId', 'roleType'])
  },
  mounted() {
  },
  methods: {
    buildClass() {
      this.$router.push({
        name: 'TeachingSpace',
        params: {
          bookId: this.bookId
        }
      })
      //this.$refs.addClass.open(null, false, this.bookId)
    },
    joinClass() {
      this.$refs.join.open()
    },
    refresh() {
      this.$router.go(0)
    }
  },
  watch: {
  }
}
</script>

<style lang='scss' scoped>
  .no-class {
    .no-img {
      width: 60px;
      height: 60px;
      background: url("~@/assets/nodata/no_teacher.png") center no-repeat;
      background-size: cover;
      margin: auto;
    }
    margin: 51px auto;
    text-align: center;
    .no-text {
      margin-top: 8px;
      margin-bottom: 20px;
      font-size: 14px;
      color: #B9BECC;
    }
    .no-img1 {
      background: url("~@/assets/nodata/no_student.png") center no-repeat;
      background-size: cover;
    }
    .icon-plus {
      vertical-align: -1px;
    }
    .no-text1 {
      padding: 20px 42px;
      color: #B9BECC;
      font-size: 12px;
      i {
        margin-right: 5px;
        font-size: 12px;
      }
    }
  }
</style>
